import '../../assets/css/learn.css';
import BlogsSection from "./BlogsSection";

export default function Learn() {
    document.title = "Learn";
    return (
        <>
            <BlogsSection />
        </>
    );
}

